const url: string =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:8000/sigmas"
    : "https://backend.sigmadeltaalpha.com/sigmas";

export default url;
